export default "__VITE_ASSET__Clp3eeCM__"